// Utils/Api/VerifyBusinessOtp.js
import { executePost } from "../ServiceMethods";

export const VerifyBusinessOtp = async (data, cb) => {
  try {
    const res = await executePost(
      "/businessuser/verify-business-map-otp",
      data
    );
    return res.data;
  } catch (error) {
    cb && cb();
    return false;
  }
};
